export default __webpack_public_path__ + "static/media/laundry2-after-1920w.79e6d94e.png";